

/**
 * A report that exists in the old Appsmith app but has not been rebuilt
 * yet. Named rather than hidden, so the team can see what is coming and
 * nobody goes looking for it in Appsmith by mistake.
 */
export default function ComingSoon({
  title,
  source,
}: {
  title: string;
  source: string;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-24 text-center">
      <p className="text-base font-semibold text-[#333333]">{title}</p>
      <p className="max-w-md text-sm text-gray-500">
        Not rebuilt yet. It still runs on {source} in the old reporting app.
      </p>
    </div>
  );
}
